module.exports = __webpack_public_path__ + "img/智能客服.6d4348d6.png";